module.exports = __webpack_public_path__ + "img/geofisica2_4-3.86327a31.webp";